import React from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import CssBaseline from '@material-ui/core/CssBaseline'
import LocalAirportIcon from '@material-ui/icons/LocalAirport'
import Header from './components/Header'
import Content from './components/Content'
import Footer from './components/Footer'
import ScrollToTop from './components/ScrollToTop'
import Logo from './images/logo.png'
import GA from './utils/GoogleAnalytics'

window.addEventListener('scroll', () => {
  const toTop = document.getElementById('toTopButton')
  if (window.pageYOffset >= 500) {
    toTop.style.display = 'block'
  } else {
    toTop.style.display = 'none'
  }
})

const App = () => {
  return (
    <div className="App">
      <div className="loading">
        <img src={Logo} alt="LOGO" width="160" />
      </div>
      <div className="AppInner">
        <CssBaseline />
        <Router>
          {GA.init() && <GA.RouteTracker />}
          <ScrollToTop>
            <Header />
            <Route exact path="/" render={() => <Content page="HOME" />} />
            <Route path="/about" render={() => <Content page="ABOUT" />} />
            <Route path="/topics" render={() => <Content page="TOPICS" />} />
            <Route
              path="/schedule"
              render={() => <Content page="SCHEDULE" />}
            />
            <Route
              path="/alltimeschedule"
              render={() => <Content page="ALL TIME SCHEDULE" />}
            />
            <Route path="/tour" render={() => <Content page="TOUR" />} />
            <Route
              path="/worldmap"
              render={() => <Content page="WORLD MAP" />}
            />
            <Footer />
            <div
              id="toTopButton"
              className="toTopButton"
              onClick={() => {
                window.scrollTo(0, 0)
              }}
            >
              <LocalAirportIcon />
            </div>
          </ScrollToTop>
        </Router>
      </div>
    </div>
  )
}

export default App
